import { render, staticRenderFns } from "./IconComment.vue?vue&type=template&id=2d4ba900&scoped=true&"
import script from "./IconComment.vue?vue&type=script&lang=js&"
export * from "./IconComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4ba900",
  null
  
)

export default component.exports